import { Component } from '@angular/core';
import { ProviderBaseComponent } from '../../provider/provider-base/provider-base.component';

@Component({
  selector: 'client-base',
  templateUrl: './client-base.component.html'
})
export class ClienBaseComponent extends ProviderBaseComponent {
}
